import React  from 'react'
import styles from './Category.module.css'
import classnames from 'classnames'
// se pone una clase con un background-position diferente en base cuantas estrellas quieres mostrar 

export default ({value, type, className}) =>  value < 1 ? null : <div className={classnames(styles[`${type}-${value}`], className)} />

